import { defaultMemoize } from 'reselect';
import { graphDefault } from './';

// This pattern is used to define multiple other tokens so we're using defaultMemoize to increase performance.
export const graphAxisLines = defaultMemoize((theme, parameters) => {
  const graphDefaultPattern = graphDefault(theme, parameters);
  switch (theme.baseThemeName) {
    case 'dark':
      {
        return {
          lineColor: graphDefaultPattern.n5,
          lineStyle: 'solid',
          lineThickness: 1 // TODO: should use dpx
        };
      }

    case 'high-contrast':
      {
        return {
          lineColor: graphDefaultPattern.white,
          lineStyle: 'solid',
          lineThickness: 2 // TODO: should use dpx
        };
      }

    default:
      {
        return {
          lineColor: graphDefaultPattern.n_3,
          lineStyle: 'solid',
          lineThickness: 1 // TODO: should use dpx
        };
      }
  }
});
//# sourceMappingURL=graphAxisLines.js.map